import { SET_SELECTED_LOCATION } from "../../constants/ActionTypes";

export const SelectedLocationId = (payload, name) => {
  return {
    type: SET_SELECTED_LOCATION,
    locationId: payload,
    locationName: name,
  };
};
